import PropTypes from "prop-types";
import { Fragment, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import clsx from "clsx";
import { getDiscountPrice } from "../../helpers/product";
import Rating from "./sub-components/ProductRating";
import ProductModal from "./ProductModal";
import { addToCart } from "../../store/slices/cart-slice";
import { addToWishlist } from "../../store/slices/wishlist-slice";
import { addToCompare } from "../../store/slices/compare-slice";
import ModalSeleccion from "../../pages/other/ModalSeleccion";
import cogoToast from "cogo-toast";
import { useNavigate } from "react-router-dom";

import IconBioequivalente from "../../assets/icono-bioequivalente.png"
import prodPresencial from "../../data/productos_presencial";

import { IconDespacho, IconRecetaSimple, IconRetiro, IconVentaDirecta } from "../../assets/icons-producto";

const ProductGridListSingle = ({
  product,
  currency,
  cartItem,
  wishlistItem,
  compareItem,
  spaceBottomClass
}) => {
  const [modalShow, setModalShow] = useState(false);
  const navigate = useNavigate();

  const { modalidadSeleccionada } = useSelector((state) => state.modalidad);

  // const discountedPrice = getDiscountPrice(product.price, product.discount);
  // const finalProductPrice = +(product.price * currency.currencyRate).toFixed(2);
  const discountedPrice = getDiscountPrice(product.precio);
  const finalProductPrice = +(product.precio).toFixed(2);
  const finalDiscountedPrice = +(
    discountedPrice * currency.currencyRate
  ).toFixed(2);
  const dispatch = useDispatch();

  const handleAddToCart = (product) => {
    setSeleccionVisible(true)

    //dispatch(addToCart(product));
  };

  const anadirFavoritos = (product) => {
    //console.log("anadirFavoritos")
    dispatch(addToWishlist(product));
    cogoToast.success(<div className="text-center">
      <div className="pt-2 pb-2">
        <a href={process.env.PUBLIC_URL + "/favoritos"} className="boton">Ver favoritos</a>
      </div>
    </div>, { position: "top-center", heading: "Producto añadido a favoritos", hideAfter: 5 });
  }


  const anadirComparar = (product) => {
    //console.log("anadirComparar")
    dispatch(addToCompare(product));
    cogoToast.success(<div className="text-center">
      <div className="pt-2 pb-2">
        <a href="/comparacion" className="boton">Ver comparación</a>
      </div>
    </div>, { position: "top-center", heading: "Producto añadido a comparación", hideAfter: 5 });
  }

  const [seleccionVisible, setSeleccionVisible] = useState(false)
  const [objProducto, setObjProducto] = useState(product)
  return (
    <Fragment key={product.kinf2}>
      <div className={clsx("product-wrap", spaceBottomClass)}>
        <div className="product-img">
          <Link to={process.env.PUBLIC_URL + "/product/" + product.kinf2}>
            {
              product.image.length === 0 ?
                <img
                  className="default-img"
                  src={product.image[0]}
                  alt=""
                /> :
                <img
                  className="default-img"
                  src={product.image[0]}
                  alt=""
                />
            }
          </Link>
          {
            product.bioequivalente === "BE" ?
              <div className="d-flex" style={{ placeContent: "flex-end", position: "relative", top: "-45px", marginBottom: "-50px" }}>
                <img src={IconBioequivalente} style={{ height: "50px", width: "50px" }} />
              </div>

              : null
          }
          <p style={{ paddingTop: "15px" }} className="p-nombre-med text-capitalize">{(product.nombre_medicamento + " (" + product.contenido + ")").toLowerCase()}</p>

          <p style={{ paddingTop: "5px" }} className="p-laboratorio text-capitalize">{(product.principio_activo + " " + product.concentracion).toLowerCase()}</p>
          <p className="p-precio-producto">{"$" + product.precio.toLocaleString("es-CL")}</p>
          <div className="separator"></div>
          <div className="d-flex align-items-center box-producto-modalidad">


            {
              product.tipo_venta === "Receta Cheque" ?
                <i style={{ fontSize: "16px", fontWeight: 600 }} className="pe-7s-shopbag" />
                :

                modalidadSeleccionada.tipo === "retiro" ?
                  <IconRetiro />
                  :
                  <IconDespacho />
            }
            {
              product.tipo_venta === "Receta Cheque" ?
                <a
                  style={{
                    fontSize: "12px",
                    paddingLeft: "4px"
                  }}
                  target="_blank" href="https://www.ligaepilepsia.cl/buscador-de-medicamentos/">{"Ver disponibilidad en sedes"}</a>
                :
                <p>{modalidadSeleccionada.nombre}</p>
            }

          </div>
          <div className="d-flex align-items-center box-producto-modalidad">

            {
              product.tipo_venta === "Directa" ?
                <IconVentaDirecta /> : <IconRecetaSimple />
            }

            <p>{product.tipo_venta}</p>
            {/* {
              product.req_rx === true ?
                <IconRecetaSimple />
                :
                <IconVentaDirecta />
            }
            <p>{product.req_rx ? "Receta simple" : "Venta Directa"}</p> */}
          </div>



          <div className="d-flex align-items-center justify-content-between pt-2">
            <div className="pro-same-action pro-wishlist">
              <button
                className={wishlistItem !== undefined ? "active btn-fav-comparacion" : "btn-fav-comparacion"}
                disabled={wishlistItem !== undefined}
                title={
                  wishlistItem !== undefined
                    ? "Añadido a favoritos"
                    : "Añadir a favoritos"
                }
                onClick={() => anadirFavoritos(product)}
              >
                <i className="pe-7s-like" />
              </button>
            </div>
            <div className="pro-same-action pro-cart ">
   
{/* //2 botones, uno para receta cheque y otro para los demas */}
              {
                product.tipo_venta !== "Receta Cheque" ?
                  <button
                    className={product.stock === 0 ? "ps-3 pe-3 btn-disabled" : "btn-carro"}
                    onClick={product.stock === 0 ? () => navigate(process.env.PUBLIC_URL + "/product/" + product.kinf2) : () => handleAddToCart(product)}
                    //disabled
                  >{product.stock === 0 ? "Ver producto" : "Añadir al carro"}</button>
                  : null
              }
               {
                product.tipo_venta === "Receta Cheque" ?
                  <button
                    //className={product.stock === 0 ? "ps-3 pe-3 btn-disabled" : "btn-carro"}
                    //onClick={product.stock === 0 ? () => navigate(process.env.PUBLIC_URL + "/product/" + product.kinf2) : () => handleAddToCart(product)}
                    disabled
                  >{"Sólo venta presencial"}</button>
                  : null
              }


              {/* { product.id_cond_venta === 2 ?
                  (<p style={{ fontSize: 14, fontWeight: 500 }}>Sólo venta presencial</p>) :
                  product.affiliateLink ? (
                    <a
                      href={product.affiliateLink}
                      rel="noopener noreferrer"
                      target="_blank"
                    >
                      {" "}
                      Buy now{" "}
                    </a>
                  ) : product.variation && product.variation.length >= 1 ? (
                    <Link to={`${process.env.PUBLIC_URL}/product/${product.kinf2}`}>
                      Select Option
                    </Link>
                  ) : product.stock && product.stock > 0 ? (
                    <button
                      onClick={() => handleAddToCart(product)}

                      className={
                        cartItem !== undefined && cartItem.quantity > 0
                          ? "active btn-carro"
                          : "btn-carro"
                      }
                      disabled={cartItem !== undefined && cartItem.quantity > 0}
                      title={
                        cartItem !== undefined ? "Añadido al carro" : "Añadir al carro"
                      }
                    >
                      {cartItem !== undefined && cartItem.quantity > 0
                        ? "Añadido"
                        : "Añadir al carro"}
                    </button>
                  ) : (
                    <button disabled className="active">
                      Sin stock
                    </button>
                  )} */}
            </div>
            <div className="pro-same-action pro-quickview ">
              <button onClick={() => setModalShow(true)} title="Vista rápida" className="btn-fav-comparacion">
                <i className="pe-7s-look" />
              </button>
            </div>
          </div>
          {/* {product.discount || product.new ? (
            <div className="product-img-badges">
              {product.discount ? (
                <span className="pink">-{product.discount}%</span>
              ) : (
                ""
              )}
              {product.new ? <span className="purple">New</span> : ""}
            </div>
          ) : (
            ""
          )} */}

          <div className="product-action">
            {seleccionVisible ?

              <ModalSeleccion
                showModalSeleccion={seleccionVisible}
                handleCloseModalSeleccion={() => setSeleccionVisible(false)}
                objMedicamento={objProducto}
              />
              : null
            }

            {/* <div className="pro-same-action pro-wishlist">
              <button
                className={wishlistItem !== undefined ? "active" : ""}
                disabled={wishlistItem !== undefined}
                title={
                  wishlistItem !== undefined
                    ? "Añadido a favoritos"
                    : "Añadir a favoritos"
                }
                onClick={() => anadirFavoritos(product)}
              >
                <i className="pe-7s-like" />
              </button>
            </div>
            <div className="pro-same-action pro-cart">
              {
              product.id_cond_venta ===2 ?
              (<p style={{color: "white", fontSize: 14, fontWeight: 500}}>Sólo venta presencial</p>) : 
              product.affiliateLink ? (
                <a
                  href={product.affiliateLink}
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  {" "}
                  Buy now{" "}
                </a>
              ) : product.variation && product.variation.length >= 1 ? (
                <Link to={`${process.env.PUBLIC_URL}/product/${product.kinf2}`}>
                  Select Option
                </Link>
              ) : product.stock && product.stock > 0 ? (
                <button
                  onClick={() => handleAddToCart(product)}

                  className={
                    cartItem !== undefined && cartItem.quantity > 0
                      ? "active"
                      : ""
                  }
                  disabled={cartItem !== undefined && cartItem.quantity > 0}
                  title={
                    cartItem !== undefined ? "Añadido al carro" : "Añadir al carro"
                  }
                >
                  {" "}
                  <i className="pe-7s-cart"></i>{" "}
                  {cartItem !== undefined && cartItem.quantity > 0
                    ? "Añadido"
                    : "Añadir al carro"}
                </button>
              ) : (
                <button disabled className="active">
                  Sin stock
                </button>
              )}
            </div>
            <div className="pro-same-action pro-quickview">
              <button onClick={() => setModalShow(true)} title="Vista rápida">
                <i className="pe-7s-look" />
              </button>
            </div> */}
          </div>
        </div>
        {/* <div className="product-content text-center">
          <h3>
            <Link to={process.env.PUBLIC_URL + "/product/" + product.kinf2}>
              {product.nombre_medicamento}
            </Link>
          </h3>
          {product.rating && product.rating > 0 ? (
            <div className="product-rating">
              <Rating ratingValue={product.rating} />
            </div>
          ) : (
            ""
          )}
          <div className="product-price">
            {discountedPrice !== null ? (
              <Fragment>
                <span>{"$" + finalDiscountedPrice.toLocaleString("es-CL")}</span>{" "}
                <span className="old">
                  {"$" + finalProductPrice.toLocaleString("es-CL")}
                </span>
              </Fragment>
            ) : (
              <span>{"$" + finalProductPrice.toLocaleString("es-CL")} </span>
            )}
          </div>
        </div> */}
      </div>
      {/* <div className="shop-list-wrap mb-30">
        <div className="row">
          <div className="col-xl-4 col-md-5 col-sm-6">
            <div className="product-list-image-wrap">
              <div className="product-img">
                <Link to={process.env.PUBLIC_URL + "/product/" + product.kinf2}>
                  <img
                    className="default-img img-fluid"
                    src={product.image[0]}
                    alt=""
                  />
                  <img
                    className="default-img img-fluid"
                    src={product.img_url_0}
                    alt=""
                  />
                  {product.image.length > 1 ? (
                    <img
                      className="hover-img img-fluid"
                      src={process.env.PUBLIC_URL + product.image[1]}
                      alt=""
                    />
                  ) : (
                    ""
                  )}
                </Link>
                {product.discount || product.new ? (
                  <div className="product-img-badges">
                    {product.discount ? (
                      <span className="pink">-{product.discount}%</span>
                    ) : (
                      ""
                    )}
                    {product.new ? <span className="purple">New</span> : ""}
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>
          <div className="col-xl-8 col-md-7 col-sm-6">
            <div className="shop-list-content">
              <h3>
                <Link to={process.env.PUBLIC_URL + "/product/" + product.kinf2}>
                  {product.nombre_medicamento}
                </Link>
              </h3>
              <div className="product-list-price">
                {discountedPrice !== null ? (
                  <Fragment>
                    <span>
                      {"$" + finalDiscountedPrice.toLocaleString("es-CL")}
                    </span>{" "}
                    <span className="old">
                      {"$" + finalProductPrice.toLocaleString("es-CL")}
                    </span>
                    <span>
                      {currency.currencySymbol + finalDiscountedPrice}
                    </span>{" "}
                    <span className="old">
                      {currency.currencySymbol + finalProductPrice}
                    </span>
                  </Fragment>
                ) : (
                  <span>{"$" + finalProductPrice.toLocaleString("es-CL")} </span>
                  // <span>{currency.currencySymbol + finalProductPrice} </span>
                )}
              </div>
              {product.rating && product.rating > 0 ? (
                <div className="rating-review">
                  <div className="product-list-rating">
                    <Rating ratingValue={product.rating} />
                  </div>
                </div>
              ) : (
                ""
              )}
              {product.shortDescription ? (
                <p>{product.shortDescription}</p>
              ) : (
                ""
              )}

              <div className="shop-list-actions d-flex align-items-center">
                <div className="shop-list-btn btn-hover">
                  {product.affiliateLink ? (
                    <a
                      href={product.affiliateLink}
                      rel="noopener noreferrer"
                      target="_blank"
                    >
                      {" "}
                      Buy now{" "}
                    </a>
                  ) : product.variation && product.variation.length >= 1 ? (
                    <Link
                      to={`${process.env.PUBLIC_URL}/product/${product.kinf2}`}
                    >
                      Select Option
                    </Link>
                  ) : product.stock && product.stock > 0 ? (
                    <button
                      onClick={() => dispatch(addToCart(product))}
                      className={
                        cartItem !== undefined && cartItem.quantity > 0
                          ? "active"
                          : ""
                      }
                      disabled={
                        cartItem !== undefined && cartItem.quantity > 0
                      }
                      title={
                        cartItem !== undefined
                          ? "Añadido al carro"
                          : "Añadir al carro"
                      }
                    >
                      {" "}
                      <i className="pe-7s-cart"></i>{" "}
                      {cartItem !== undefined && cartItem.quantity > 0
                        ? "Añadido"
                        : "Añadir al carro"}
                    </button>
                  ) : (
                    <button disabled className="active">
                      Sin stock
                    </button>
                  )}
                </div>

                <div className="shop-list-wishlist ml-10">
                  <button
                    className={wishlistItem !== undefined ? "active" : ""}
                    disabled={wishlistItem !== undefined}
                    title={
                      wishlistItem !== undefined
                        ? "Añadido a favoritos"
                        : "Añadir a favoritos"
                    }
                    onClick={() => anadirFavoritos(product)}
                  >
                    <i className="pe-7s-like" />
                  </button>
                </div>
                <div className="shop-list-compare ml-10">
                  <button
                    className={compareItem !== undefined ? "active" : ""}
                    disabled={compareItem !== undefined}
                    title={
                      compareItem !== undefined
                        ? "Añadido para comparar"
                        : "Añadir para comparar"
                    }
                    onClick={() => anadirComparar(product)}
                  >
                    <i className="pe-7s-note2" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}
      {/* product modal */}
      <ProductModal
        show={modalShow}
        onHide={() => setModalShow(false)}
        product={product}
        currency={currency}
        discountedPrice={discountedPrice}
        finalProductPrice={finalProductPrice}
        finalDiscountedPrice={finalDiscountedPrice}
        wishlistItem={wishlistItem}
        compareItem={compareItem}
        key={product.kinf2}

      />
    </Fragment>
  );
};

ProductGridListSingle.propTypes = {
  cartItem: PropTypes.shape({}),
  compareItem: PropTypes.shape({}),
  currency: PropTypes.shape({}),
  product: PropTypes.shape({}),
  spaceBottomClass: PropTypes.string,
  wishlistItem: PropTypes.shape({})
};

export default ProductGridListSingle;
